(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/prolongation/assets/javascripts/views/prolongation.js') >= 0) return;  svs.modules.push('/modules/lotto/components/prolongation/assets/javascripts/views/prolongation.js'); 
'use strict';

svs.lotto.components.prolongation.views.Prolongation = Marionette.View.extend({
  regions: {
    prolongationContentRegion: '#prolongationContentRegion'
  },
  template(data) {
    return svs.lotto.components.prolongation.templates.prolongation(data);
  },
  onRender() {
    const bagsBySize = svs.lotto.data.bagTypeIdMap;
    this.showChildView('prolongationContentRegion', new svs.numbergames.prolongation.views.Prolongation({
      productId: svs.numbergames.productMapping.CONSTANTS.LOTTO,
      syndicates: svs.syndicate.account_selector.data.syndicates,
      prolongWagerFunctions: {
        editWager: svs.numbergames.game.utils.prolongation.getEditWagerFunction({
          bagsBySize,
          playViews: {
            Single: svs.lotto.views.PlaySinglePage,
            System: svs.lotto.views.PlaySystemPage,
            Package: svs.lotto.views.PlayPackagePage
          }
        }),
        payWager: svs.numbergames.game.utils.prolongation.getPayWagerFunction({
          bagsBySize
        })
      }
    }));
  }
});
 })(window);